// extracted by mini-css-extract-plugin
export default {"img":"improve_img__5cLlJ","item":"improve_item__Z5lRi","galery":"improve_galery__kpe0c","improve":"improve_improve__mTcD2","title":"improve_title__VOmOv"};